<div class="configuracion-servicios">
  <app-config-panel
    [title]="'Configuración'"
    [description]="
      'Administra las configuraciones de servicios e integraciones'
    "
    [tabs]="tabs"
    [(activeTab)]="activeTab"
  >
    <ng-container [ngSwitch]="activeTab">
      <!-- SERVICIO EXTERNO -->
      <div *ngSwitchCase="'servicio'">
        <div class="config-section-header">
          <div>
            <h3>Configuración del servicio</h3>
          </div>
        </div>

        <app-servicio></app-servicio>
      </div>

      <!-- CREDENCIALES -->
      <div *ngSwitchCase="'credenciales'">
        <div class="config-section-header">
          <div>
            <h3>Credenciales</h3>

            <p>Administra las credenciales utilizadas por las integraciones.</p>
          </div>
        </div>

        <app-archivo-configuracion></app-archivo-configuracion>
      </div>

      <!-- BUCKET -->
      <div *ngSwitchCase="'bucket'">
        <div class="config-section-header">
          <div>
            <h3>Configuración del almacenamiento</h3>

            <p>
              Configura el proveedor y las credenciales del sistema de archivos.
            </p>
          </div>
        </div>
        <app-list-bucket></app-list-bucket>
      </div>

      <!-- BUCKET -->
      <div *ngSwitchCase="'flujos'">
        <div class="config-section-header">
          <div>
            <h3>Flujos</h3>

            <p>Configura flujo del servicio.</p>
          </div>
        </div>
        <app-list-flujo></app-list-flujo>
      </div>
    </ng-container>
  </app-config-panel>
</div>
